import { Sanitize } from '../../Sanitize/Sanitize';
import LinkSVG from '../Components/Link.svg';

import { makeText } from '../../../util';

const Tag = ({ vendor, accordionOpen }) => (
  <a tabIndex={accordionOpen ? 0 : -1} href={vendor.policyUrl} target="_blank" className="vendor-tag linked">
    <span>{vendor.name}</span>
    <img src={LinkSVG} alt="" />
  </a>
);

export const VendorContent = ({
  vendor,
  settings,
  language,
  dev,
  consentType,
  accordionOpen,
}) => {
  const cookieText = makeText(Boolean(dev), settings, 'cookieText', language);
  const tableCookieText = makeText(Boolean(dev), settings, 'tableCookieText', language);
  const tableCategoryText = makeText(Boolean(dev), settings, 'tableCategoryText', language);
  const tableDomainText = makeText(Boolean(dev), settings, 'tableDomainText', language);
  const tableDurationText = makeText(Boolean(dev), settings, 'tableDurationText', language);

  // IAB Categories
  const iabConsent = makeText(Boolean(dev), settings, 'iabConsent', language);
  const iabLegInt = makeText(Boolean(dev), settings, 'iabLegInt', language);
  const iabFeatures = makeText(Boolean(dev), settings, 'iabFeatures', language);
  const iabSpecialFeatures = makeText(Boolean(dev), settings, 'iabSpecialFeatures', language);
  const iabSpecialPurposes = makeText(Boolean(dev), settings, 'iabSpecialPurposes', language);
  return (
    <div className="vendor-content">
      {vendor.description && (
        <p className="pm-sub-p" dangerouslySetInnerHTML={{ __html: Sanitize({ html: vendor.description }) }} />
      )}
      {vendor.cookieHeader && (
        <div className="vendor-cookie-header">{vendor.cookieHeader}</div>
      )}
      <Tag vendor={vendor} accordionOpen={accordionOpen} /> 
      <div>
        {(consentType === 'consent') && vendor.consentCategories.length > 0 && (
          <div className="vendor-info">
            <h3>{iabConsent}</h3>
            {vendor.consentCategories.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {(consentType === 'li') && vendor.legIntCategories.length > 0 && (
          <div className="vendor-info">
            <h3>{iabLegInt}</h3>
            {vendor.legIntCategories.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {vendor.iabFeatures.length > 0 && (
          <div className="vendor-info">
            <h3>{iabFeatures}</h3>
            {vendor.iabFeatures.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {vendor.iabSpecialFeatures.length > 0 && (
          <div className="vendor-info">
            <h3>{iabSpecialFeatures}</h3>
            {vendor.iabSpecialFeatures.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {vendor.iabSpecialPurposes.length > 0 && (
          <div className="vendor-info">
            <h3>{iabSpecialPurposes}</h3>
            {vendor.iabSpecialPurposes.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
      </div>
      {vendor.cookies.length > 0 && (
        <div className="vendor-cookies">
          <div className="cookie-title">{cookieText}</div>
          <table className="tvtbl">
            <tr>
              <th>{tableCategoryText}</th>
              <th>{tableCookieText}</th>
              <th>{tableDomainText}</th>
              <th>{tableDurationText}</th>
            </tr>
            {vendor.cookies.map((c) => (
              <tr>
                <td className="category-td no-content">{c.categoryName}</td>
                <td><span>{c.name}</span></td>
                <td className="no-content">{c.domain}</td>
                <td><span>{c.cookieLifeSpan}</span></td>
              </tr>
            ))}
          </table>
        </div>

      )}
    </div>
  );
};